import React from 'react';
import LocationTemplate from './LocationTemplate';

const ChinquapinPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Chinquapin"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28521"]}
      latitude={34.8257}
      longitude={-77.8547}
      population={304}
      historicalFact="Named after the chinquapin tree (a type of chestnut tree); incorporated in 1905."
      nearbyTowns={[
        "Wallace, NC",
        "Rose Hill, NC",
        "Magnolia, NC",
        "Teachey, NC",
        "Kenansville, NC",
        "Warsaw, NC",
        "Burgaw, NC",
        "Turkey, NC"
      ]}
    />
  );
};

export default ChinquapinPage;